import { ROUTES } from '@endurance/platform-contracts';

export default ROUTES;
